import { ChangeEventHandler, forwardRef, InputHTMLAttributes, LegacyRef, memo } from 'react';

import { withController } from '@/lib/v2/HOCs/WithController';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label?: string;
  children?: JSX.Element;
  name?: string;
  disabled?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  checked?: boolean;
  value?: string | number | readonly string[];
  error?: boolean;
  message?: string;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      id,
      label,
      name,
      children,
      disabled,
      onChange,
      value,
      checked,
      error,
      message,
      ...restOfProps
    }: CheckboxProps,
    ref: LegacyRef<HTMLInputElement>
  ): JSX.Element => {
    return (
      <div className="relative flex flex-col items-start" data-testid="checkbox-component">
        <div className="flex items-center">
          <div className="flex items-center">
            <input
              ref={ref}
              checked={checked}
              className="h-4 w-4 rounded border-gray-300 accent-emblue-primary focus:outline-none"
              disabled={disabled}
              id={id}
              name={name}
              type="checkbox"
              value={value}
              onChange={onChange}
              {...restOfProps}
            />
          </div>
          <div className="text-sm ml-1">
            {label ? (
              <label
                className="block h-full text-left text-14 font-normal text-emblue-text"
                htmlFor={id}
              >
                {label}
              </label>
            ) : (
              children
            )}
          </div>
        </div>
        {error && (
          <p className={'message-error'} id={`${name}-message`}>
            {message}
          </p>
        )}
      </div>
    );
  }
);

export default memo(withController(Checkbox));
